export const administrationAccountsSiteLocationRscAssistants = {
    template: require('./administration-accounts-site-location-rsc-assistants.html'),
    controller: 'AdministrationAccountsSiteLocationRscAssistantsController'
};
